(function($){
    $('.navbar-toggler').on('click', function(){
       $('.fullscreen-menu').slideDown(500);
    });
    $(document).ready(function(){
        if($(window).width() < 992){
            $('.fullscreen-menu .menu-item-has-children > a, .treatments-menu > a, .problem-menu > a, .has-arrow > a').each(function(){
                $(this).append('<img src="/wp-content/themes/wrosinski/img/submenu.svg" />');
            });

            $('body').on('click', '.fullscreen-menu .menu-item-has-children > a, .fullscreen-menu .treatments-menu > a, .fullscreen-menu .problem-menu > a', function(e){
                e.preventDefault();
                var menu = $(this).next('.sub-menu').html();
                var title = $(this).text();
                var aclass = '';
                if($(this).next('.sub-menu').hasClass('treatments-sub-menu') || $(this).next('.sub-menu').attr('data-type') == 'problems'){
                    aclass = 'has-treatments';
                    title = $(this).attr('data-slug');
                }
                $('.fullscreen-menu > ul').slideUp(300);
                $('.sub-menu-card').html('<ul class="sub-menu navbar-nav '+aclass+'">'+menu+'</ul>').slideDown(300);
                if(aclass != ''){
                    $('.' + aclass).attr('data-slug', $(this).closest('li').attr('data-slug'));
                }
                $('.fullscreen-menu .top-info-menu .go-to-home').html(title);
                $('.fullscreen-menu .top-info-menu').addClass('submenu-opened');
                $('.fullscreen-menu .top-info-menu .hide-sub-menu').remove();
                $('.fullscreen-menu .top-info-menu').prepend('<a href="#" class="hide-sub-menu"><img src="/wp-content/themes/wrosinski/img/submenu.svg" /></a>');
            });
            $('body').on('click', '.fullscreen-menu .hide-menu', function(e){
                e.preventDefault();
                $('.fullscreen-menu').slideUp(300);
                setTimeout(function(){
                    hide_sub_menu();
                }, 301)
            });
            $('body').on('click', '.fullscreen-menu .hide-sub-menu', function(e){
                e.preventDefault();
                hide_sub_menu();
            })

            function hide_sub_menu(){
                var back_side = false;
                if($('.sub-menu-card .sub-menu').attr('data-slug')){
                    back_side = $('.sub-menu-card .sub-menu').attr('data-slug');
                }
                $('.sub-menu-card').slideUp(300);
                $('.fullscreen-menu > ul').slideDown(300);
                $('.fullscreen-menu .top-info-menu .hide-sub-menu').remove();
                $('.fullscreen-menu .top-info-menu .go-to-home').html('<img src="'+$('.fullscreen-menu .top-info-menu .go-to-home').attr('data-img')+'" />');
                $('.fullscreen-menu .top-info-menu').removeClass('submenu-opened');
                if(back_side){
                    $('.fullscreen-menu .treatments-menu > a').click();
                }
                else{

                }
            }
        }
    })
})(jQuery)